import Formsy from "formsy-react";
import * as React from "react";
import { SelfServiceClient } from "../api/ApiClient";
import EmailInput from "../components/EmailInput";
import PhoneInput from "../components/PhoneInput";
import { UserContext } from "../context/UserContext";

interface Props {}
interface State {
  editable: boolean;
  posting: boolean;
  valid: boolean;
  message: string;
}

export class Contact extends React.Component<Props, State> {
  private formRef: React.RefObject<any> = React.createRef();
  private posting: boolean = false;

  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  private readonly selfServiceClient: SelfServiceClient =
    new SelfServiceClient();

  async componentDidMount() {
    this.selfServiceClient.setToken(this.context.token);
  }

  state = { editable: false, posting: false, valid: true, message: "" };

  render() {
    return !this.context.customer ? null : (
      <div>
        <h2>Mina kontaktuppgifter</h2>
        {this.state.editable ? (
          <React.Fragment>
            <Formsy
              ref={this.formRef}
              formNoValidate
              noValidate={true}
              onSubmit={this.save}
              onValid={this.onValidForm}
              onInvalid={this.onInvalidForm}>
              <div className="form-group">
                <label className="control-label mt-2 mb-0">Mobilnummer</label>
                <PhoneInput name="phone" value={this.context.customer.mobile} />
              </div>
              <div className="form-group">
                <label className="control-label mt-2 mb-0">Epostadress</label>
                <EmailInput name="email" value={this.context.customer.email} />
              </div>
              <button
                type="submit"
                className="btn btn-submit mt-2 mr-1"
                disabled={this.state.posting || !this.state.valid}>
                Spara
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-2 ml-1"
                disabled={this.state.posting}
                onClick={this.toogleEdit}>
                Ångra
              </button>
              {this.state.message && <p>{this.state.message}</p>}
            </Formsy>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <p>
              Mobilnummer: {this.context.customer.mobile}
              <br />
              Epostadress: {this.context.customer.email}
            </p>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toogleEdit}>
              Ändra
            </button>
          </React.Fragment>
        )}
      </div>
    );
  }

  onValidForm = () => {
    this.setState({
      valid: true,
    });
  };

  onInvalidForm = () => {
    this.setState({
      valid: false,
    });
  };

  toogleEdit = () => {
    this.setState({ editable: !this.state.editable });
  };

  save = async () => {
    if (this.posting || !this.state.valid) {
      return;
    }

    this.setState({ posting: true });
    console.debug("Saveing customer", this.formRef.current.getModel());

    let formModel = this.formRef.current.getModel();
    let customer = Object.assign({}, this.context.customer);
    customer.phone = formModel.phone;
    customer.email = formModel.email;
    try {
      let updatedCustomer = await this.selfServiceClient.updateCustomer(
        window.location.href,
        customer
      );
      this.context.setCustomer(updatedCustomer);
      this.posting = false;
      this.setState({ editable: false, posting: false });
    } catch (error) {
      console.error("Failed to update customer", error);
      this.posting = false;
      this.setState({ message: "Något gick fel", posting: false });
    }
  };
}
